import React, { useState, useEffect } from "react";
import {
    Box,
    Menu,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
    GetDateTimeStringToday,
    GetDateTimeStringYesterday,
    GetDateTimeString7DaysAgo,
    GetDateTimeString14DaysAgo,
    GetDateTimeString30DaysAgo,
    GetDateTimeString90DaysAgo,
    GetDateTimeString2DaysAgo,
    GetDateTimeString60DaysAgo,
    GetDateTimeString180DaysAgo,
    GetDateTimeString28DaysAgo,
} from "../utils/systemInfo";
import moment from "moment";
import DevicesService from "../api/devices";
import HomePagesMenu from "../common/HomePagesMenu";
import Loading from "../common/loading";
import NumberTypography from "../common/NumberTypography";
import Breadcrumbs from "../common/breadcrumbs";
import SearchInput from "../common/searchInput.js";
// import handleNavigate from "../common/customFunctions/handleNavigate.js";
import StateHistoryComponent from "../common/stateHistoryComponent";
import ProfileService from "../api/profile";
import NamedLocationsService from "../api/namedLocations";
import AddEditDeviceStateHistory from "./addEditDeviceStateHistory";
import handleNavigate from "../common/customFunctions/handleNavigate";
// import CircleIcon from "@mui/icons-material/Circle";
// import {RadioButtonUnchecked} from "@mui/icons-material";

const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
    height: "36px",
    backgroundColor: theme.palette.custom.buttonColor,
    color: theme.palette.custom.buttonTextColor,
    "&:hover": {
        backgroundColor: theme.palette.custom.buttonHoverColor,
        color: theme.palette.custom.buttonHoverTextColor,
        boxShadow: "none",
    },
    float: "right",
    width: "min-content",
    whiteSpace: "nowrap",
    padding: "1rem",
}));

const breadcrumbs = [
    { id: 0, name: "Home", href: "./" },
    { id: 1, name: "Maintenance", href: "maintenance" },
];

const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
    "& .MuiPaper-root": {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.custom.light,
    },
}));
const StyleSpan = styled((props) => <span {...props} />)(({ theme }) => ({
    color: theme.palette.custom.text,
}));
const timespanList = [
    {
        id: 0,
        label: "Day on Day",
        secondLabel: "Last 24 hours",
        timespan: "24 hours",
    },
    {
        id: 1,
        label: "Week on Week",
        secondLabel: "Last 7 days",
        timespan: "168 hours",
    },
    {
        id: 2,
        label: "Fortnight on Fortnight",
        secondLabel: "Last 14 days",
        timespan: "336 hours",
    },
    {
        id: 3,
        label: "Month on Month",
        secondLabel: "Last 30 days",
        timespan: "720 hours",
    },
    {
        id: 4,
        label: "Quarter on Quarter",
        secondLabel: "Last 90 hours",
        timespan: "2160 hours",
    },
];
function Maintenance() {
    const theme = useTheme();
    const { t } = useTranslation();
    //   const dispatch = useDispatch();
    const navigate = useNavigate();
    const organziation = useSelector(({ organziation }) => organziation);
    const [anchorElUser, setAnchorElUser] = useState(null);
    //   const [machineDeviceArray, setMachineDeviceArray] = useState(["Fleet"]);
    const [dateTimeStringFrom, setDateTimeStringFrom] = useState(
        GetDateTimeString7DaysAgo()
    );
    const [dateTimeStringFromBefore, setDateTimeStringFromBefore] = useState(
        GetDateTimeString14DaysAgo()
    );
    const [dateTimeStringTo, setDateTimeStringTo] = useState(
        GetDateTimeStringToday()
    );
    const [dateRangeString, setDateRangeString] = useState("Last 7 days");
    const [timespanString, setTimespanString] = useState("168 hours");
    const [timeSpanMenuLabel, setTimespanMenuLabel] = useState("Week on Week");
    const [searchText, setSearchText] = useState("");
    const [deviceStateHistoryList, setDeviceStateHistoryList] = useState([]);
    const [loadingValue, setLoadingValue] = useState(true);
    const [usersList, setUsersList] = useState([]);
    const [locationsList, setLocationsList] = useState([]);
    const [drawerState, setDrawerState] = useState(false);
    const [sortBy, setSortBy] = useState("");
    const [sortDirection, setSortDirection] = useState("asc");
    const sortOptions = [
        { value: "state_type", label: "State Type" },
        { value: "assigned_user", label: "Assigned User" },
        { value: "start_time", label: "Start Time" },
        { value: "location", label: "Location" },
        { value: "tags", label: "Tags" },
        { value: "machine_name", label: "Machine Name" },
        { value: "machine_type", label: "Machine Type" },
        { value: "oem", label: "OEM" },
    ];
    // console.log(stateHistory)
    useEffect(() => {
        const apiKey =
            organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
        ProfileService.GetUserProfile({
            profile_uid: "",
            profile_id: "",
            app_profile_uid: "",
            firstname: "",
            lastname: "",
            tel_primary: "",
            email_primary: "",
            status: "active",
            apiKey: apiKey,
        })
            .then((json) => {
                if (json && json.person_profile && json.person_profile.length > 0) {
                    setUsersList(json?.person_profile);
                }
            })
            .catch(() => { });
        NamedLocationsService.GetNamedLocations({
            // id: id,
            apiKey,
        })
            .then((jsonCurrent) => {
                if (jsonCurrent?.config_operation_location_named_lookup?.length) {
                    setLocationsList(jsonCurrent?.config_operation_location_named_lookup);
                }
            })
            .catch((errorr) => {
                if (process.env.NODE_ENV === "development")
                    console.log("getUserTypePermissionserrorr", errorr);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const apiKey =
            organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
        console.log(dateTimeStringFromBefore);
        if (apiKey) {
            //  const apiKey = organziation?.api_key_list?.[0]?.key;
            DevicesService.GetDevicesStateHistory({
                // device_state_history_id: "",
                serial: "",
                dst: {
                    f: dateTimeStringFrom,
                    t: dateTimeStringTo,
                },
                apiKey,
            })
                .then((jsonCurrent) => {
                    console.log("Here", jsonCurrent);
                    if (jsonCurrent?.device_state_history?.length > 0) {
                        console.log(
                            "setDeviceStateHistoryList",
                            jsonCurrent?.device_state_history
                        );
                        setDeviceStateHistoryList(jsonCurrent?.device_state_history);
                        setSearchText("");
                    } else {
                        setDeviceStateHistoryList([]);
                        setSearchText("");
                    }
                    setLoadingValue(false);
                })
                .catch((errorr) => {
                    if (process.env.NODE_ENV === "development")
                        console.log("getUserTypePermissionserrorr", errorr);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateTimeStringFrom, dateTimeStringTo]);

    function getDeviceStateHistory(deviceSerial) {
        // console.log("getTags");
        const apiKey =
            organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");

        DevicesService.GetStateHistoryPerDevice({
            // device_state_history_id: "",
            serial: deviceSerial,
            dst: {
                f: dateTimeStringFrom,
                t: dateTimeStringTo,
            },
            apiKey,
        })
            .then((jsonCurrent) => {
                if (jsonCurrent?.device_state_history?.length > 0) {
                    console.log(
                        "setDeviceStateHistoryList",
                        jsonCurrent?.device_state_history
                    );
                    setDeviceStateHistoryList(jsonCurrent?.device_state_history);
                } else {
                    setDeviceStateHistoryList([]);
                }
                setLoadingValue(false);
            })
            .catch((errorr) => {
                if (process.env.NODE_ENV === "development")
                    console.log("getUserTypePermissionserrorr", errorr);
            });
    }

    const search = searchText?.toLowerCase();
    const filteredStateHistoryList = deviceStateHistoryList.filter((item) => {
        const assignedUser = usersList.find(
            (user) => user.profile_uid?.toString() === item.assigned_to_person_id
        );
        const assignedUserName = assignedUser
            ? `${assignedUser.firstname} ${assignedUser.lastname}`.toLowerCase()
            : "";

        const location = locationsList.find(
            (loc) => loc.operation_location_named_lookup_id === item.state_location_id
        );
        const locationName = location?.name?.toLowerCase() ?? "";

        const formattedStartTime = item.state_start?.toLowerCase() ?? "";

        const tagNames = (item.device_state_history_tags || [])
            .map((tag) => tag.tag_name?.toLowerCase())
            .join(" ");

        const machineName = item.device_profile?.name?.toLowerCase() ?? "";
        const machineType = item.device_profile?.machine_type?.toLowerCase() ?? "";
        const oem = item.device_profile?.oem?.toLowerCase() ?? "";

        return (
            item.state_type?.toLowerCase()?.includes(search) ||
            assignedUserName?.includes(search) ||
            formattedStartTime?.includes(search) ||
            locationName.includes(search) ||
            tagNames.includes(search) ||
            machineName.includes(search) ||
            machineType.includes(search) ||
            oem.includes(search)
        );
    });

    const sortedStateHistoryList = [...filteredStateHistoryList].sort((a, b) => {
        const getAssignedName = (item) => {
            const u = usersList.find(
                (user) => user.profile_uid?.toString() === item.assigned_to_person_id
            );
            return u ? `${u.firstname} ${u.lastname}`.toLowerCase() : "";
        };

        const getLocationName = (item) => {
            const l = locationsList.find(
                (loc) =>
                    loc.operation_location_named_lookup_id === item.state_location_id
            );
            return l?.name?.toLowerCase() ?? "";
        };

        const getTagString = (item) =>
            (item.device_state_history_tags || [])
                .map((tag) => tag.tag_name?.toLowerCase())
                .join(" ");

        const getSortValue = (item) => {
            switch (sortBy) {
                case "state_type":
                    return item.state_type?.toLowerCase() ?? "";
                case "assigned_user":
                    return getAssignedName(item);
                case "start_time":
                    return item.state_start ?? "";
                case "location":
                    return getLocationName(item);
                case "tags":
                    return getTagString(item);
                case "machine_name":
                    return item.device_profile?.name?.toLowerCase() ?? "";
                case "machine_type":
                    return item.device_profile?.machine_type?.toLowerCase() ?? "";
                case "oem":
                    return item.device_profile?.oem?.toLowerCase() ?? "";
                default:
                    return "";
            }
        };

        const aVal = getSortValue(a);
        const bVal = getSortValue(b);

        return sortDirection === "asc"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
    });
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleChooseTimespan = (item) => {
        setLoadingValue(true);
        setSearchText(null);
        setTimespanMenuLabel(item.label);
        setTimespanString(item.timespan);
        setDateRangeString(item.secondLabel);
        let DataFrom;
        let DataFromBefore;
        const DataTo = GetDateTimeStringToday();
        switch (item.id) {
            case 0:
                DataFrom = GetDateTimeStringYesterday();
                DataFromBefore = GetDateTimeString2DaysAgo();
                break;
            case 1:
            default:
                DataFrom = GetDateTimeString7DaysAgo();
                DataFromBefore = GetDateTimeString28DaysAgo();
                break;
            case 2:
                DataFrom = GetDateTimeString14DaysAgo();
                DataFromBefore = GetDateTimeStringYesterday();
                break;
            case 3:
                DataFrom = GetDateTimeString30DaysAgo();
                DataFromBefore = GetDateTimeString60DaysAgo();
                break;
            case 4:
                DataFrom = GetDateTimeString90DaysAgo();
                DataFromBefore = GetDateTimeString180DaysAgo();
                break;
        }
        setDateTimeStringFromBefore(DataFromBefore);
        setDateTimeStringFrom(DataFrom);
        setDateTimeStringTo(DataTo);
        setAnchorElUser(false);
    };
    function handleSearch(ev) {
        const newSearchText = ev.target.value;
        setSearchText(newSearchText);
    }
    function toggleDrawer(open) {
        setDrawerState(open);
    }
    return (
        <Box
            sx={{
                p: "12px",
                borderRadius: "16px",
                border: `1px solid ${theme.palette.custom.borderColor}`,
            }}
            style={{
                minHeight: "90vh",
                height: "fit-content",
            }}
        >
            <Box sx={{ width: "100%" }}>
                <Breadcrumbs breadcrumbs={breadcrumbs} />

                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: { xs: "block", sm: "center" },
                        height: "64px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            height: "inherit",
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <HomePagesMenu pageName={"Maintenance"} />
                        <StyledButton
                            sx={{ display: "flex", alignItems: "center" }}
                            onClick={(e) => {
                                handleNavigate(e, navigate, `/deviceStateHistory`);
                            }}
                        >
                            {t("View Device State History")}
                        </StyledButton>
                    </Box>
                </Box>
            </Box>
            <Divider
                sx={{ my: "10px", backgroundColor: theme.palette.custom.borderColor }}
            />

            <Box
                component="main"
                sx={{
                    p: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    borderRadius: "16px",
                    border: `1px solid ${theme.palette.custom.borderColor}`,
                    height: { xs: "fit-content", sm: "48px" },
                }}
            >
                <Box sx={{ display: { xs: "block", sm: "flex" } }}>
                    <Typography
                        sx={{ color: theme.palette.custom.text }}
                        variant="subtitle2"
                        gutterBottom
                    >
                        {t("DataSummary").toLocaleUpperCase()} &nbsp;|&nbsp;
                    </Typography>
                    <NumberTypography variant="subtitle2">
                        {t(dateRangeString)}
                        {` (${moment(dateTimeStringFrom).format("YYYY/MM/DD")} - ${moment(
                            dateTimeStringTo
                        ).format("YYYY/MM/DD")})`}
                    </NumberTypography>
                    <Typography
                        sx={{ color: theme.palette.custom.text }}
                        variant="subtitle2"
                        gutterBottom
                    >
                        &nbsp;|&nbsp;{t("Timespan")}:{timespanString}
                    </Typography>
                </Box>
                <>
                    <Tooltip title="Open settings">
                        <Button
                            variant="text"
                            onClick={handleOpenUserMenu}
                            endIcon={
                                <KeyboardArrowDownIcon
                                    sx={{ color: theme.palette.custom.text }}
                                />
                            }
                        >
                            <StyleSpan>{timeSpanMenuLabel}</StyleSpan>
                        </Button>
                    </Tooltip>
                    <StyledMenu
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                        keepMounted
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                    >
                        {timespanList &&
                            timespanList.map((item) => (
                                <MenuItem
                                    key={item.id}
                                    onClick={() => handleChooseTimespan(item)}
                                >
                                    <Typography textAlign="center">
                                        {item.label ? item.label : ""}
                                    </Typography>
                                </MenuItem>
                            ))}
                    </StyledMenu>
                </>
            </Box>
            {/* {deviceStateHistoryList && deviceStateHistoryList.length > 0 ? (
                <Box
                    sx={{
                        p: "12px",
                        display: "flex",
                        flexFlow: "column",
                        borderRadius: "16px",
                        border: `1px solid ${theme.palette.custom.borderColor}`,
                        marginTop: "5px"
                    }}>
                    <Box
                        sx={{
                            p: "12px",
                            display: "flex"
                        }}>
                        <Typography variant="h6" textAlign="center">{`${t("Planned Maintenance")} :`}</Typography>
                    </Box>
                    <Box
                        sx={{
                            p: "12px",
                            display: "flex",
                            flexFlow: "row",
                            justifyContent: "space-between",
                        }}>
                        <Box
                            sx={{
                                p: "12px",
                                display: "flex",
                                flexFlow: "column",
                                borderRadius: "16px",
                                border: `1px solid ${theme.palette.custom.borderColor}`
                            }}>
                            <Typography textAlign="left">{t("Total")}</Typography>
                            <Typography
                                sx={{
                                    fontSize: "40px",
                                    mb: 0,
                                    color: theme.palette.custom.text,
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                gutterBottom
                                textAlign="left">
                                <RadioButtonUnchecked sx={{color: "#FFFFFF", fontSize: "46px"}} />
                                {deviceStateHistoryList.length === "" ? 0 : deviceStateHistoryList.length}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                p: "12px",
                                display: "flex",
                                flexFlow: "column",
                                borderRadius: "16px",
                                border: `1px solid ${theme.palette.custom.borderColor}`
                            }}>
                            <Typography textAlign="left">{t("Open")}</Typography>
                            <Typography
                                sx={{
                                    fontSize: "40px",
                                    mb: 0,
                                    color: theme.palette.custom.text,
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                gutterBottom
                                textAlign="left">
                                <CircleIcon sx={{color: "#00FF00", fontSize: "46px"}} />
                                {deviceStateHistoryList.length === "" ? 0 : deviceStateHistoryList.length}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                p: "12px",
                                display: "flex",
                                flexFlow: "column",
                                borderRadius: "16px",
                                border: `1px solid ${theme.palette.custom.borderColor}`
                            }}>
                            <Typography textAlign="left">{t("Closed")}</Typography>
                            <Typography
                                sx={{
                                    fontSize: "40px",
                                    mb: 0,
                                    color: theme.palette.custom.text,
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                gutterBottom
                                textAlign="left">
                                <CircleIcon sx={{color: "#FF0000", fontSize: "46px"}} />
                                {deviceStateHistoryList.length === "" ? 0 : deviceStateHistoryList.length}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            p: "12px",
                            display: "flex",
                        }}>
                        <Typography variant="h6" textAlign="center">{`${t("Unplanned Maintenance")} :`}</Typography>
                    </Box>
                    <Box
                        sx={{
                            p: "12px",
                            display: "flex",
                            flexFlow: "row",
                            justifyContent: "space-between",
                        }}>
                        <Box
                            sx={{
                                p: "12px",
                                display: "flex",
                                flexFlow: "column",
                                borderRadius: "16px",
                                border: `1px solid ${theme.palette.custom.borderColor}`
                            }}>
                            <Typography textAlign="left">{t("Total")}</Typography>
                            <Typography
                                sx={{
                                    fontSize: "40px",
                                    mb: 0,
                                    color: theme.palette.custom.text,
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                gutterBottom
                                textAlign="left">
                                <RadioButtonUnchecked sx={{color: "#FFFFFF", fontSize: "46px"}} />
                                {deviceStateHistoryList.length === "" ? 0 : deviceStateHistoryList.length}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                p: "12px",
                                display: "flex",
                                flexFlow: "column",
                                borderRadius: "16px",
                                border: `1px solid ${theme.palette.custom.borderColor}`
                            }}>
                            <Typography textAlign="left">{t("Open")}</Typography>
                            <Typography
                                sx={{
                                    fontSize: "40px",
                                    mb: 0,
                                    color: theme.palette.custom.text,
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                gutterBottom
                                textAlign="left">
                                <CircleIcon sx={{color: "#00FF00", fontSize: "46px"}} />
                                {deviceStateHistoryList.length === "" ? 0 : deviceStateHistoryList.length}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                p: "12px",
                                display: "flex",
                                flexFlow: "column",
                                borderRadius: "16px",
                                border: `1px solid ${theme.palette.custom.borderColor}`
                            }}>
                            <Typography textAlign="left">{t("Closed")}</Typography>
                            <Typography
                                sx={{
                                    fontSize: "40px",
                                    mb: 0,
                                    color: theme.palette.custom.text,
                                    fontWeight: "700",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                gutterBottom
                                textAlign="left">
                                <CircleIcon sx={{color: "#FF0000", fontSize: "46px"}} />
                                {deviceStateHistoryList.length === "" ? 0 : deviceStateHistoryList.length}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        p: "12px",
                        display: "flex",
                        justifyContent: "space-between",
                        borderRadius: "16px",
                        border: `1px solid ${theme.palette.custom.borderColor}`,
                        height: {xs: "fit-content", sm: "48px"},
                        marginTop: "5px"
                    }}>
                    <Typography textAlign="center">{t("No Data Summary")}</Typography>
                </Box>
            )} */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 2,
                    justifyContent: "space-between",
                }}
            >
                <SearchInput
                    searchText={searchText}
                    handleSearch={handleSearch}
                    autoFocus
                    sx={{
                        width: { xs: "100%", sm: "40%" },
                        borderColor: theme.palette.custom.borderColor,
                        borderRadius: "11px",
                        backgroundColor: theme.palette.custom.light,
                    }}
                />
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FormControl size="small" sx={{ minWidth: 200, mr: "5px" }}>
                        <InputLabel id="sort-by-label">Sort By</InputLabel>
                        <Select
                            labelId="sort-by-label"
                            value={sortBy}
                            label="Sort By"
                            onChange={(e) => setSortBy(e.target.value)}
                        >
                            <MenuItem value="">None</MenuItem>
                            {sortOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ p: 0, minWidth: 0 }}
                        onClick={() =>
                            setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"))
                        }
                    >
                        {sortDirection === "asc" ? (
                            <KeyboardArrowUpIcon />
                        ) : (
                            <KeyboardArrowDownIcon />
                        )}
                    </Button>
                </Box>
            </Box>
            {loadingValue ? (
                <Box sx={{ height: "30vh", pt: "10%" }}>
                    <Loading />
                </Box>
            ) : sortedStateHistoryList?.length > 0 ? (
                sortedStateHistoryList.map((row, index) => (
                    <React.Fragment key={index}>
                        <StateHistoryComponent
                            usersList={usersList}
                            locationsList={locationsList}
                            row={row}
                            triggerToggleDrawer={toggleDrawer}
                        />
                        <Divider
                            sx={{
                                mb: "10px",
                                backgroundColor: theme.palette.custom.borderColor,
                            }}
                        />
                    </React.Fragment>
                ))
            ) : (
                <>No state history</>
            )}
            <SwipeableDrawer
                PaperProps={{
                    sx: {
                        color: theme.palette.custom.text,
                        display: { xs: "none", sm: "block" },
                    },
                }}
                sx={{
                    "& .MuiDrawer-paper": {
                        pt: "64px",
                        px: "10px",
                        boxSizing: "border-box",
                        width: { xs: "100%", sm: "50%" },
                        color: theme.palette.custom.text,
                    },
                }}
                anchor={"right"}
                open={drawerState}
                onClose={() => toggleDrawer(false)}
                onOpen={() => toggleDrawer(true)}
            >
                <AddEditDeviceStateHistory
                    usersList={usersList}
                    locationsList={locationsList}
                    triggerToggleDrawer={toggleDrawer}
                    refreshStateHistory={getDeviceStateHistory}
                />
            </SwipeableDrawer>
        </Box>
    );
}

export default Maintenance;
